var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.625 2C6.53466 2 6.5 2.06584 6.5 2.1V4.3C6.5 4.33416 6.53466 4.4 6.625 4.4H13.375C13.4653 4.4 13.5 4.33416 13.5 4.3V2.1C13.5 2.06584 13.4653 2 13.375 2H6.625ZM15.5 2.2V2.1C15.5 0.919135 14.5273 0 13.375 0H6.625C5.4727 0 4.5 0.919136 4.5 2.1V2.2H3.25C2.39521 2.2 1.57102 2.53181 0.959892 3.12936C0.347998 3.72765 0 4.54396 0 5.4V20.8C0 21.656 0.347998 22.4723 0.959892 23.0706C1.57102 23.6682 2.39521 24 3.25 24H16.75C17.6048 24 18.429 23.6682 19.0401 23.0706C19.652 22.4723 20 21.656 20 20.8V5.4C20 4.54396 19.652 3.72765 19.0401 3.12936C18.429 2.53181 17.6048 2.2 16.75 2.2H15.5ZM15.5 4.2V4.3C15.5 5.48086 14.5273 6.4 13.375 6.4H6.625C5.4727 6.4 4.5 5.48086 4.5 4.3V4.2H3.25C2.91132 4.2 2.59091 4.33176 2.35813 4.55937C2.12611 4.78624 2 5.08908 2 5.4V20.8C2 21.1109 2.12611 21.4138 2.35813 21.6406C2.59091 21.8682 2.91132 22 3.25 22H16.75C17.0887 22 17.4091 21.8682 17.6419 21.6406C17.8739 21.4138 18 21.1109 18 20.8V5.4C18 5.08908 17.8739 4.78624 17.6419 4.55937C17.4091 4.33176 17.0887 4.2 16.75 4.2H15.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupIcon);
export default __webpack_public_path__ + "static/media/setupIcon.192409517b3efb692c5b569243632fdf.svg";
export { ForwardRef as ReactComponent };